import api from '@utils/api';
import classNames from 'classnames';
import useScrollDirection from '@utils/useScrollDirection';
import React, { useEffect, useState, useRef } from 'react';
import CollectionIntroTabs from './CollectionIntroTabs';
import '@styles/components/collection-intro-simplified/collection-intro-simplified.scss';
const CollectionIntroHeader = (props) => {
    const [pageData, setPageData] = useState(null);
    const [collectionsTab, setCollectionsTab] = useState(null);
    const [stickyExpanded, setStickyExpanded] = useState(false);
    const [componentName, setComponentName] = useState();
    const [imagesUrl, setImagesUrl] = useState(null);
    const scrolldirection = useScrollDirection({ initialDirection: 'up' });
    const wrapperRef = useRef(null);
    const stickyWrapper = useRef(null);
    useEffect(() => {
        var _a;
        const pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        api.getPageJson(pageID, true).then((data) => {
            var _a, _b;
            const formattedData = data === null || data === void 0 ? void 0 : data.getFormattedData(data);
            const componentDataRes = (_a = formattedData.main) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
            setComponentName(componentDataRes.type_id);
            setImagesUrl((_b = componentDataRes === null || componentDataRes === void 0 ? void 0 : componentDataRes.custom) === null || _b === void 0 ? void 0 : _b.imagesUrl);
            setCollectionsTab(componentDataRes === null || componentDataRes === void 0 ? void 0 : componentDataRes.collectionsTab);
            setPageData(componentDataRes === null || componentDataRes === void 0 ? void 0 : componentDataRes.data);
        });
        document.addEventListener('scroll', handleScroll);
        return () => {
            document.removeEventListener('scroll', handleScroll);
            document.removeEventListener('click', clickOutsideCallback);
        };
    }, []);
    useEffect(() => {
        const downScroll = scrolldirection == 'down';
        window.requestAnimationFrame(() => document.body.classList.toggle('page-scrolled-up', !downScroll));
        window.requestAnimationFrame(() => document.body.classList.toggle('page-scrolled', downScroll));
    }, [scrolldirection]);
    const clickOutsideCallback = (e) => {
        if (!stickyWrapper.current.contains(e.target)) {
            setStickyExpanded(false);
            document.removeEventListener('click', clickOutsideCallback);
        }
    };
    const handleScroll = () => {
        var _a;
        const header = document.querySelector('header');
        let scrollAmount = header && header.offsetHeight;
        if (scrollAmount) {
            document.body.style.setProperty('--headerHeight', `${scrollAmount / 10}rem`);
            setStickyExpanded(false);
            document.removeEventListener('click', clickOutsideCallback);
        }
        const scrollPastWrapper = ((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().bottom) < 0;
        window.requestAnimationFrame(() => document.body.classList.toggle('sticky-intro-disabled', !scrollPastWrapper));
    };
    const onStickyClickHandler = () => {
        const toExpand = !stickyExpanded;
        setStickyExpanded(toExpand);
        if (toExpand) {
            document.addEventListener('click', clickOutsideCallback);
        }
        else {
            document.removeEventListener('click', clickOutsideCallback);
        }
    };
    if (!pageData) {
        return React.createElement("div", { className: "placeholder" });
    }
    const withTabs = pageData.withTabs;
    const withImage = (imagesUrl === null || imagesUrl === void 0 ? void 0 : imagesUrl.bgImage) && (imagesUrl === null || imagesUrl === void 0 ? void 0 : imagesUrl.bgImageMobile);
    const gradientTypeClass = pageData.imgGradient === 'Bright' ? 'image-background--bright' : 'image-background--darker';
    const gradientSizeClass = pageData.gradientSize === 'Half' ? 'image-background--half' : pageData.gradientSize === 'Top' ? 'image-background--top' : 'image-background--whole';
    const logo = (fromSticky) => {
        const logoUrl = fromSticky ? imagesUrl === null || imagesUrl === void 0 ? void 0 : imagesUrl.sticky_logo : imagesUrl === null || imagesUrl === void 0 ? void 0 : imagesUrl.logo;
        return logoUrl && React.createElement("img", { className: fromSticky ? 'collection-intro-sticky__logo' : 'collection-intro__logo', src: logoUrl, alt: "" });
    };
    const stickyNameIcon = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "collection-intro-sticky__name" }, pageData.collectionTitle),
            React.createElement("span", { className: "collection-intro-sticky__toggle-icon" })));
    };
    const stickyElement = () => {
        return (React.createElement("div", { className: "collection-intro-sticky", ref: stickyWrapper },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "row align-middle" },
                    React.createElement("div", { className: "col-12 col-md-4 collection-intro-sticky__heading" },
                        React.createElement("div", { className: "collection-intro-sticky__heading--desktop" },
                            logo(true),
                            stickyNameIcon()),
                        React.createElement("button", { className: classNames('collection-intro-sticky__btn', { expanded: stickyExpanded }), "aria-expanded": stickyExpanded, "aria-controls": `collection-intro-sticky-list--${props.uuid}`, onClick: onStickyClickHandler },
                            logo(true),
                            stickyNameIcon())),
                    React.createElement("div", { className: classNames('col-md-8 text-right', { expanded: stickyExpanded }), id: `collection-intro-sticky-list--${props.uuid}` },
                        React.createElement("ul", { className: "collection-intro-sticky__links" }, collectionsTab === null || collectionsTab === void 0 ? void 0 : collectionsTab.map((introTab) => {
                            var _a;
                            const tabData = introTab.data;
                            const dataAnalytics = {
                                event: componentName,
                                eventCategory: componentName,
                                eventAction: 'banner interaction',
                                eventLabel: `${(_a = pageData.collectionTitle_analytics) === null || _a === void 0 ? void 0 : _a.toLowerCase()}-${(tabData.tabTitle_analytics || tabData.tabTitle || '').toLowerCase()}`,
                            };
                            return (React.createElement("li", { className: "collections-intro__tab", key: introTab.id },
                                React.createElement("a", { href: tabData.link || tabData.tabLink, className: "collection-intro__tab-name", "data-analytics-id": introTab.id, "data-analytics": JSON.stringify(dataAnalytics) }, tabData.linkText || tabData.tabTitle)));
                        })))))));
    };
    const textContent = () => {
        const titleFont = pageData.title_typo === 'BlockGothicRR' ? pageData.title_typo : '';
        return (React.createElement("div", { className: "collection-intro-simplified__content" },
            logo(),
            React.createElement("h1", { className: 'collection-intro__name ' + titleFont }, pageData.collectionTitle),
            React.createElement("div", { className: "collection-intro__description", dangerouslySetInnerHTML: { __html: pageData.description } })));
    };
    return (React.createElement(React.Fragment, null,
        collectionsTab && stickyElement(),
        React.createElement("div", { className: 'collection-intro collection-intro-simplified' + (withImage ? ' with-image' : ''), ref: wrapperRef },
            withImage ? (React.createElement("div", { className: "collection-intro__img-wrapper" },
                React.createElement("span", { className: `collection-intro__img ${gradientTypeClass} ${gradientSizeClass}` },
                    React.createElement("picture", null,
                        React.createElement("source", { media: "(min-width:600px)", srcSet: imagesUrl === null || imagesUrl === void 0 ? void 0 : imagesUrl.bgImage }),
                        React.createElement("img", { src: imagesUrl === null || imagesUrl === void 0 ? void 0 : imagesUrl.bgImageMobile, alt: "", "aria-hidden": "true" }))),
                textContent())) : (textContent()),
            React.createElement(CollectionIntroTabs, { withTabs: withTabs, collectionsTab: collectionsTab, type: componentName, collectionTitleAnalytics: pageData.collectionTitle_analytics }))));
};
export default CollectionIntroHeader;
